/** @flow */
import React from "react";
import classNames from "classnames";

type ButtonGroupProps = $Exact<{
  fillSpace?: boolean,
  className?: string,
  children: React$Node,
  disabled?: boolean,
}>;

const ButtonGroup = (props: ButtonGroupProps) => (
  <div
    className={classNames(
      "button-group",
      {
        "fill-space": props.fillSpace,
        disabled: props.disabled,
      },
      props.className,
    )}
  >
    {props.children}
  </div>
);

export default ButtonGroup;
